import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

import { INNER_BOTTOM_SPACE_DESK, colorsPalette } from '../../theme';

const useStyles = (background, forceDarkOnMobile) =>
  makeStyles((theme: Theme) =>
    createStyles({
      wrapper: {
        paddingTop: 36,
        paddingBottom: 36,
        background: forceDarkOnMobile
          ? theme.palette.secondary.dark
          : background === 'Dark'
          ? theme.palette.secondary.dark
          : theme.palette.secondary.light,
        '&:first-child': {
          marginTop: 76,
        },

        [theme.breakpoints.up('sm')]: {
          paddingTop: 72,
          paddingBottom: 72,
          background:
            background === 'Dark' ? theme.palette.secondary.dark : theme.palette.secondary.light,

          '&:first-child': {
            marginTop: 120,
          },
        },
      },
      container: {},
      content: {
        padding: '36px 10px',
      },
      headingWrapper: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        justifyContent: 'center',
        alignItems: 'center',
      },
      heading: {
        marginBottom: 22,
        [theme.breakpoints.up('sm')]: {
          marginBottom: INNER_BOTTOM_SPACE_DESK,
        },
      },
      description: {
        fontSize: 18,
        lineHeight: 1.5,
        color: colorsPalette.gray,
        textAlign: 'center',
        marginBottom: 72,
        [theme.breakpoints.up('sm')]: {
          maxWidth: '70%',
        },
      },
      experts: {
        display: 'flex !important',
        flexWrap: 'wrap',
        marginBottom: -24,
      },
      expertsDesk: {
        display: 'flex',
        flexWrap: 'wrap',
        marginBottom: -24,
        marginRight: -30,
        justifyContent: 'center',

        [theme.breakpoints.down('md')]: {
          flexWrap: 'wrap',
          justifyContent: 'center',
        },
      },
      expert: {
        width: 'calc(50% - 7.5px)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center',
        marginRight: 15,
        marginBottom: 24,

        '&:nth-child(2n)': {
          marginRight: 0,
        },

        [theme.breakpoints.up('sm')]: {
          width: 'calc(20% - 30px)',
          marginRight: 30,

          '&:nth-child(2n)': {
            marginRight: 30,
          },
        },
      },
      imgWrapper: {
        width: '100%',
        height: 0,
        paddingBottom: '100%',
        overflow: 'hidden',
        borderRadius: '100%',
        position: 'relative',
        marginBottom: 25,

        '& img': {
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          objectFit: 'cover',
        },
      },
      textWrapper: {
        width: '100%',
      },
      name: {
        fontSize: 18,
        fontWeight: 'bold',
        marginBottom: 5,
      },
      jobTitle: {
        fontSize: 16,
        color: '#C9C4D4',
        width: '100%',
      },
      dots: {
        display: 'flex !important',
        alignItems: 'center',
        justifyContent: 'center',
        margin: 0,
        padding: 0,
        listStyleType: 'none',
        marginTop: 22,

        '& li': {
          display: 'flex',
          marginRight: 10,

          '&:last-child': {
            marginRight: 0,
          },
        },

        '& .slick-active button': {
          width: 10,
          height: 10,
          background: theme.palette.primary.main,
        },

        '& button': {
          width: 12,
          height: 12,
          padding: 0,
          fontSize: 0,
          background: 'transparent',
          borderWidth: '2px',
          borderStyle: 'solid',
          borderColor: colorsPalette.whiteSecondary,
          borderRadius: '100%',
        },
      },
    }),
  );
export default useStyles;
